import Vue from 'vue'
import { DynamicFormField } from '../../DynamicFormTypes'

export function useDateFormatting() {
  const formatDateValue = (value: any, field: DynamicFormField): string => {
    if (!value) return ''

    try {
      const momentDate = Vue.moment(value)
      const dateFormat = ('dateFormat' in field && field.dateFormat) || 'l'
      return momentDate.local().format(dateFormat)
    } catch (error) {
      console.error('Error formatting date:', error)
      return String(value)
    }
  }

  return {
    formatDateValue
  }
}
